<template>

  <div>
    <md-autocomplete v-model="term"
                     @md-changed="handleSearch"
                     @md-opened="handleSearch"
                     @md-selected="handleItemSelected"
                     :md-options="items">
      <label v-if="label">{{label}}</label>

      <template slot="md-autocomplete-item" slot-scope="{ item, term }">
        <md-highlight-text :md-term="term">{{item.id}}</md-highlight-text>
      </template>

      <template slot="md-autocomplete-empty" slot-scope="{ term }">
        Type to search stores
      </template>

    </md-autocomplete>

    <div v-if="multiple">
      <md-chip v-for="item in selectedItemIds" md-deletable @md-delete="handleItemDeleted(item)">
        {{item}}
      </md-chip>
    </div>
  </div>


</template>

<script>
  import { mapGetters } from 'vuex';
  import api from '../api';

  export default {
    props: {
      value: [String, Array],
      label: String,
      multiple: String,
      onSelectedItemIdsChanged: Function,
      onStoreSelected: Function,
      initSelectedIds: Array,
      joinEndOutlets: Boolean,
    },
    data: () => ({
      selectedStoreId: null,
      selectedItemIds: [],
      items: [],
      term: '',
    }),
    computed: {
      ...mapGetters([
        'getAllStoreOptions',
        'getMasterDataName',
        'getMasterDataAsSelectOptionByGroup',
      ]),
      allOptions() {
        let allStoreOptions = this.getAllStoreOptions;
        if (this.joinEndOutlets === true) {
          allStoreOptions = allStoreOptions
            .concat(this.getMasterDataAsSelectOptionByGroup('EndOutletMilkRun1'))
            .concat(this.getMasterDataAsSelectOptionByGroup('EndOutletMilkRun2'))
        }
        return allStoreOptions;
      },
    },
    watch: {
      selectedStoreId(val) {
        this.$emit('input', val);
        if (this.onStoreSelected && _.isFunction(this.onStoreSelected)) {
          this.onStoreSelected(val);
        }
      },
      selectedItemIds(val) {
        this.$emit('input', val);
        if (this.onSelectedItemIdsChanged && _.isFunction(this.onSelectedItemIdsChanged)) {
          this.onSelectedItemIdsChanged(val);
        }
      },
      value(val) {
        if (this.multiple) {
          if (this.selectedItemIds !== val) {
            this.selectedItemIds = val;
          }
        } else {
          if (this.selectedStoreId !== val) {
            this.selectedStoreId = val;
          }
        }

      },
    },
    mounted() {
      this.$nextTick(() => {
        if (this.initSelectedIds) {
          this.selectedItemIds = _(this.initSelectedIds).filter(it => !!it);
        } else if (this.value) {
          this.selectedItemIds = this.value;
          this.term = this.value;
        }
      });
    },
    methods: {
      handleSearch(term) {
        if (this.selectedStoreId && term !== this.selectedStoreId) {
          this.selectedStoreId = null;
          return;
        }

        const allStoreOptions = this.allOptions;

        this.items = new Promise(resolve => {
          if (!term || term.length <= 1) {
            resolve([]);
          } else {
            resolve(
              _(allStoreOptions).chain()
                .filter(it => it.id.startsWith(term))
                .take(10)
                .value()
            )
          }
        });
      },
      clear() {
        console.log(`clear`);
        this.term = '';
        this.selectedItemIds = [];
        this.selectedStoreId = null;
      },
      handleItemSelected(item) {
        console.log(`handleItemSelected`, item.id);
        if (this.multiple) {
          this.selectedItemIds.push(item.id);
          this.selectedItemIds = _(this.selectedItemIds).uniq();
          this.term = '';
          this.$nextTick(() => {
            this.term = '';
          });
        } else {
          this.selectedStoreId = item.id;
          this.term = this.selectedStoreId;
          this.$nextTick(() => {
            this.term = this.selectedStoreId;
          });
        }
      },
      handleItemDeleted(itemId) {
        console.log(`handleItemDeleted`, itemId);
        this.selectedItemIds = _(this.selectedItemIds).without(itemId);
      }
    },
  };
</script>
